import { Link } from 'react-router-dom';

/**
 * HM-076 — Conflict queue badge in header dashboard.
 * Sempre 0 in Fase 1 (no cloud sync). Click → /conflicts.
 */
export function ConflictBadge({ count }: { count: number }) {
  return (
    <Link
      to="/conflicts"
      data-testid="conflict-badge"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        background: count > 0 ? '#E74C3C' : '#cbd5e1',
        color: count > 0 ? '#fff' : '#475569',
        textDecoration: 'none',
        padding: '4px 10px',
        borderRadius: 12,
        fontSize: 12,
        fontWeight: 600,
      }}
      aria-label={`Conflict queue (${count})`}
    >
      <span aria-hidden="true">!</span>
      Conflicts <span data-testid="conflict-count">{count}</span>
    </Link>
  );
}
